export const SDK_GET_RETRY_COUNT = 2;
